module.exports = __webpack_public_path__ + "static/media/YF39_2.fc4a3c6a.jpg";